<template>
  <SubmenuMainContainer v-model:currentMenu="currentMenu" :menus="menus">
    <template #[SubsectionKey.UserList]>
      <UsersTemplate />
    </template>

    <template #[SubsectionKey.ProfilesList]>
      <ProfilesTemplate />
    </template>
  </SubmenuMainContainer>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { UserAddOutlined, TeamOutlined } from "@ant-design/icons-vue";

import SubmenuMainContainer from "@/app/shared/components/organisms/SubmenuMainContainer.vue";
import UsersTemplate from "@/app/users/components/templates/UsersTemplate.vue";
import ProfilesTemplate from "@/app/users/components/templates/ProfilesTemplate.vue";

enum MenuKey {
  Users = "users",
  Profiles = "profiles",
}

enum SubsectionKey {
  UserList = "users-list",
  ProfilesList = "profile-list",
}

const menus = [
  {
    name: "Listado de usuarios",
    key: MenuKey.Users,
    sections: [
      {
        key: SubsectionKey.UserList,
        title: "Listado de usuarios",
        icon: UserAddOutlined,
      },
    ],
  },
  {
    name: "Gestión de perfiles",
    key: MenuKey.Profiles,
    sections: [
      {
        key: SubsectionKey.ProfilesList,
        title: "Gestión de perfiles",
        icon: TeamOutlined,
      },
    ],
  },
];

const currentMenu = ref(MenuKey.Users);
</script>
